<div class="main">
    <div class="container">
        <div class="brand-name">
            <a href="https://www.zisson.com/zisson-socialboards/"><strong>Socialboards</strong></a>
        </div>
        <h1>
            <span translate>Access restricted</span>
        </h1>
        <p class="info-text">
            <span translate>The FAQ section is available to authorized users only.</span>
            <br />
            <a (click)="login()" translate>Log in</a>
        </p>

        <div class="image-wrapper">
            <img src="/sb-tools/theme/images/errors/error-403.png" alt="403" />
        </div>
    </div>
</div>
